/**
 * Utility function to disable arrow key changes in number input fields
 */
export const disableNumberInputArrows = () => {
  const numberInputs = document.querySelectorAll('input[type="number"]');
  
  numberInputs.forEach(input => {
    input.addEventListener('keydown', function(e: Event) {
      const keyboardEvent = e as KeyboardEvent;
      if (keyboardEvent.key === 'ArrowUp' || keyboardEvent.key === 'ArrowDown') {
        e.preventDefault();
      }
    });
  });
};

/**
 * Initialize the arrow key prevention for number inputs
 * Call this function when the DOM is ready
 */
export const initNumberInputArrowPrevention = () => {
  // Initial setup for existing inputs
  disableNumberInputArrows();
  
  // Watch for dynamically added number inputs
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const element = node as Element;
          const numberInputs = element.querySelectorAll('input[type="number"]');
          numberInputs.forEach(input => {
            input.addEventListener('keydown', function(e: Event) {
              const keyboardEvent = e as KeyboardEvent;
              if (keyboardEvent.key === 'ArrowUp' || keyboardEvent.key === 'ArrowDown') {
                e.preventDefault();
              }
            });
          });
        }
      });
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}; 